import { render, staticRenderFns } from "./AppNotification.vue?vue&type=template&id=0062d4d3&scoped=true&lang=pug"
import script from "./AppNotification.vue?vue&type=script&lang=ts"
export * from "./AppNotification.vue?vue&type=script&lang=ts"
import style0 from "./AppNotification.vue?vue&type=style&index=0&id=0062d4d3&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0062d4d3",
  null
  
)

export default component.exports